import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@polyai/ui/styles/wipe.css';
import 'rsuite/dist/rsuite-no-reset.min.css';
import '@polyai/ui/styles/tailwind.css';

import App from 'app/index';

const root = document.getElementById('root')!;
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
